import { Tabs as MantineTabs } from "@mantine/core";

import BackgroundWrapper from "_components/atoms/backgroundWrapper";
import Typography        from "_components/atoms/typography";

import useStyles from "./styles";

const Tabs = ( { tabs, activeTab, setActiveTab, onClickHandler = () => {} } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<MantineTabs
			unstyled
			className = { classes.tabRoot }
			onChange  = { setActiveTab }
			value     = { activeTab }
		>
			<BackgroundWrapper className = { classes.backgroundWrapper }>
				<MantineTabs.List
					className = { classes.tabList }
				>
					{
						tabs.map ( tab => {
							return (
								<MantineTabs.Tab
									key     = { tab?.type }
									onClick = { () => {
										if ( tab.type !== activeTab ) {
											onClickHandler ( { type: tab.type } );
										}
									} }
									value   = { tab?.type }
								>
									<Typography
										className = { classes.tabText }
										title     = { tab?.title }
									/>
								</MantineTabs.Tab>
							);
						} )
					}
				</MantineTabs.List>

			</BackgroundWrapper>
		</MantineTabs>
	);
};

export default Tabs;
